import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { ColDef, SelectionChangedEvent } from 'ag-grid-community'
import { Button, ConfigProvider, Flex, Input, Pagination, PaginationProps, Switch, Table, TableProps } from 'antd'
import viVN from 'antd/locale/vi_VN'
import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import Layout from '../../../Layout'
import * as customerHobbyApi from '../../../api/customerHobby/customerHobbyApi'
import BreadcrumbBlock from '../../../components/BreadcrumbBlock/BreadcrumbBlock'
import ModalDeleteManager from '../../../components/ModalDeleteManager'
import useDebounce from '../../../hook/useDebounce'
import useLoading from '../../../hook/useLoading'
import useThrottle from '../../../hook/useThrottle'
import useToast from '../../../hook/useToast'
import { NO_DATA } from '../../../services/data'
import { formatNumber } from '../../../services/mixin'
import { selectorPermission } from '../../../store/slices/permissionSlice'
import { dataPagination, getUserPermissions } from '../../../until'
import AddHobbyModal from './AddHobbyModal'
import EditHobbyModal from './EditHobbyModal'
import { AgGridReact } from 'ag-grid-react'

const { Search } = Input

interface TableDataType {
  key: React.Key
  code: string
  name: string
  status: number
}
type TableRowSelection<T extends object = object> = TableProps<T>['rowSelection']

const CustomerHobby: React.FC = () => {
  useEffect(() => {
    return () => {
      setFilterHobby(undefined)
      gListHobby([])
      setPagination({ current: 1, pageSize: 10, total: 0 })
    }

  }, [])


  const location = useLocation();
  const pushLoading = useLoading()
  const pushToast = useToast();
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, } = getUserPermissions(permissionSlice, location.pathname)

  const [showAddHobbyModal, setShowAddHobbyModal] = useState(false)
  const [showEditHobbyModal, setShowEditHobbyModal] = useState(false)
  const [showDeleteHobbyModal, setShowDeleteHobbyModal] = useState(false)

  const [loadingTable, setLoadingTable] = useState(false)

  const [paginationTmp, setPaginationTmp] = useState<number>(1)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [filterHobby, setFilterHobby] = useState<string>()

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [idHobby, setIdHobby] = useState<number>()
  const [infoCustomerHobby, setInfoCustomerHobby] = useState<customerHobbyApi.IHobbyEdit>()
  const [listCustomerHobby, setListCustomerHobby] = useState<TableDataType[]>([])

  //#region: COLUMNS
  const memoizedColumnDefs = useMemo<ColDef<TableDataType>[]>(() => [
    {
      headerName: 'Hành động',
      field: 'key',

      width: 180,
      resizable: false,
      suppressMovable: true,
      lockPosition: 'left',

      cellRenderer: (params: any) => {
        const record = params.data as TableDataType;

        if (!record) return null;

        return (
          <div className='d-flex gap-2 align-center h-full'>
            <EditOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${!edit ? 'disabled' : ''}`}
              onClick={() => {
                if (edit) gInfoHobby(Number(record.key));
              }}
            />
            <DeleteOutlined
              className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${!isdelete ? 'disabled' : ''}`}
              onClick={() => {
                if (isdelete) openModalDeleteHobby(Number(record.key));
              }}
            />
          </div>
        );
      },
    },

    {
      headerName: 'Mã sở thích',
      field: 'code',

      minWidth: 180,

      cellRenderer: (params: any) => {
        return (
          <div className="td-card-code">
            {params.value || NO_DATA}
          </div>
        );
      },
    },

    {
      headerName: 'Tên sở thích',
      field: 'name',

      minWidth: 220,
      flex: 1,
      valueFormatter: (params) => {
        return params.value || NO_DATA;
      },
    },

    {
      headerName: 'Sử dụng',
      field: 'status',

      width: 130,
      minWidth: 130,
      maxWidth: 130,

      headerClass: 'ag-header-cell-right',

      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },

      cellRenderer: (params: any) => {
        const record = params.data as TableDataType;

        if (!record) return null;

        return (
          <Switch
            checked={Boolean(record.status)}
            onChange={() => {
              updateStatusHobby(Number(record.key));
            }}
            className="rs-switch"
          />
        );
      },
    },
  ], [edit, isdelete]);
  //#endregion

  //#region TABLE ROW SELECTION
  const onSelectionChanged = (
    event: SelectionChangedEvent<TableDataType>
  ) => {
    const selectedKeys = event.api
      .getSelectedRows()
      .map(item => item.key);

    setSelectedRowKeys(selectedKeys);

    console.log('selectedRowKeys:', selectedKeys);
  };
  const getRowId = (params: any) =>
    String(params.data.key);
  //#endregion

  // Danh sách sở thích
  const gListHobby = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    setLoadingTable(true)
    const result = await customerHobbyApi.gListHobby(pageSize, pageCurent, filterHobby)
    if (result?.status) {

      setListCustomerHobby(convertData(result?.data, pageCurent, pageSize))
      setPagination({ current: pageCurent, total: result.total, pageSize })
      setPaginationTmp(pageCurent)
    } else {
      pushToast(result?.message, "warning")
    }
    setLoadingTable(false)
  }, 1000)

  const convertData = (data: customerHobbyApi.IHobby[], pageCurent: number, pageSize: number) => {
    const converData = data.map((items) => ({
      key: items.id,
      name: items.title,
      status: items.status,
      code: items.code
    }))
    return converData
  }
  // Thông tin sở thích
  const gInfoHobby = useThrottle(async (id: number) => {
    pushLoading(true)
    const result = await customerHobbyApi.gInfoHobby(id)
    if (result?.status) {
      setInfoCustomerHobby(result?.data)
      setShowEditHobbyModal(true)
    } else {
      pushToast(result.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  // Thêm sở thích
  const submitModalAdd = (iSsuccess: boolean, errorMessage?: string) => {
    if (iSsuccess) {
      setShowAddHobbyModal(false)
      pushToast("Thêm sở thích thành công", "success")
      gListHobby()
    } else {
      pushToast(errorMessage, "warning")
    }
  }

  // Chỉnh sửa sở thích
  const submitModalEdit = (isSucces: boolean, errorMessage?: string) => {
    if (isSucces) {
      setShowEditHobbyModal(false)
      pushToast("Chỉnh sửa sở thích thành công", "success")
      gListHobby(pagination.current, pagination.pageSize)
    } else {
      pushToast(errorMessage, "warning")
    }
  }

  const openModalDeleteHobby = (id: number) => {
    setIdHobby(id)
    setShowDeleteHobbyModal(true)
  }

  const closeModalDeleteHobby = () => {
    setIdHobby(undefined)
    setShowDeleteHobbyModal(false)
  }

  // Xóa sở thích
  const onDeleteHobby = async () => {
    pushLoading(true)
    const result = await customerHobbyApi.deleteHobby(Number(idHobby))
    if (result.status) {
      pushToast("Xóa sở thích thành công", "success")
      closeModalDeleteHobby()
      gListHobby(pagination.current, pagination.pageSize)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }

  // Update trạng thái
  const updateStatusHobby = async (id: number) => {
    const result = await customerHobbyApi.updateStatusHobby(id)
    if (result?.status) {
      gListHobby(pagination.current, pagination.pageSize)
      pushToast(result.message, "success", 2000)
    } else {
      pushToast(result.message, "error", 2000)
    }
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPaginationTmp(pageNumber);
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListHobby(pageNumber, pageSize)
  }

  useEffect(() => {
    gListHobby()
  }, [filterHobby])

  return (
    <>
      {/* MODAL ADD HOBBY */}
      <AddHobbyModal
        show={showAddHobbyModal}
        modalClose={() => setShowAddHobbyModal(false)}
        onSubmitFormModal={submitModalAdd}
      />

      {/* MODAL EDIT HOBBY */}
      <EditHobbyModal
        show={showEditHobbyModal}
        infoCustomerHobby={infoCustomerHobby}
        modalClose={() => setShowEditHobbyModal(false)}
        onSubmitModalEdit={submitModalEdit}
      />

      {/* MODAL DELETE HOBBY */}
      <ModalDeleteManager
        isOpen={showDeleteHobbyModal}
        title='Xóa sở thích'
        titleDelete='Xóa'
        content='Sở thích và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục'
        closeModal={closeModalDeleteHobby}
        onConfirm={onDeleteHobby}
      />
      <Layout className='customer-hobby'>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: 'Khách hàng', },
            { title: 'Quản lý sở thích', },
          ]}
          title='Quản lý sở thích'
          className='gutter-block-end'
        />

        <Flex vertical className='gap-18px h-full'>
          <Flex align='center' className='gap-12px'>
            <Search
              placeholder="Tìm kiếm sở thích"
              allowClear
              className="custom-input-css"
              value={filterHobby}
              onChange={(e) => setFilterHobby(e.target.value)}
            />
            <Button
              type='primary'
              disabled={!add}
              // className={` ${!add && "disabled"}`}
              onClick={() => setShowAddHobbyModal(true)}
            >Thêm sở thích</Button>
          </Flex>

          <div className="custom-page-css flex flex-1 flex-col justify-between">
            <div
              className="ag-theme-alpine custom-table-ag custom-css-table"
              style={{
                width: '100%',
                height:
                  listCustomerHobby.length === 0
                    ? 250
                    : listCustomerHobby.length < 10
                      ? listCustomerHobby.length * 55 + 55
                      : 650,
              }}
            >
              <AgGridReact<TableDataType>
                rowData={listCustomerHobby}
                columnDefs={memoizedColumnDefs}

                getRowId={getRowId}

                rowHeight={55}
                headerHeight={48}

                defaultColDef={{
                  resizable: true,
                  sortable: true,
                }}

                rowSelection={{
                  mode: 'multiRow',
                  checkboxes: true,
                  headerCheckbox: true,
                  enableClickSelection: false,
                }}

                onSelectionChanged={onSelectionChanged}

                loading={loadingTable}

                overlayNoRowsTemplate="<span>Không có dữ liệu</span>"

                enableCellTextSelection
                ensureDomOrder

                getRowStyle={(params: any) => ({
                  backgroundColor:
                    params?.node?.rowIndex % 2
                      ? '#f7f9fc'
                      : '#ffffff',
                })}
              />
            </div>
            <ConfigProvider locale={viVN}>
              <div className="pagination-block">
                <Pagination
                  showSizeChanger
                  current={paginationTmp}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  itemRender={(page, type, originalElement) => {
                    // Chỉ custom khi là nút số trang
                    if (type === 'page') {
                      return <span>{formatNumber(page)}</span>;
                    }
                    // prev / next / jump-prev / jump-next giữ nguyên
                    return originalElement;
                  }}
                  showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, paginationTmp).totalPage} trang`}
                  className='rs-pagination'
                  onChange={onPaginationChange}
                />
              </div>
            </ConfigProvider>
          </div>
        </Flex>
      </Layout>


    </>
  )
}

export default CustomerHobby
